import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-6" data-testid="verify-page">
      <div className="max-w-md w-full bg-white border border-[#E6E4DF] rounded-lg p-10 text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8" data-testid="verify-brand">
          <div className="w-8 h-8 rounded-md bg-[#1C3F35] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5}/>
          </div>
          <span className="font-heading text-lg">Beacon of Grants</span>
        </Link>

        {status === "verifying" && (
          <>
            <Loader2 className="w-10 h-10 text-[#1C3F35] mx-auto animate-spin"/>
            <h1 className="font-heading text-3xl mt-6">Verifying…</h1>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="w-14 h-14 rounded-full bg-[#1C3F35] mx-auto flex items-center justify-center">
              <CheckCircle2 className="w-8 h-8 text-white"/>
            </div>
            <h1 className="font-heading text-4xl mt-6 font-light tracking-tight">Email verified.</h1>
            <p className="text-[#5E5E5E] mt-2">You're all set. Head to your dashboard.</p>
            <Link to="/dashboard">
              <Button data-testid="verify-cta" className="mt-8 bg-[#1C3F35] text-white hover:bg-[#1A362D] w-full py-6">
                Open dashboard
              </Button>
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <div className="w-14 h-14 rounded-full bg-[#C1654B] mx-auto flex items-center justify-center">
              <XCircle className="w-8 h-8 text-white"/>
            </div>
            <h1 className="font-heading text-3xl mt-6">Verification failed</h1>
            <p className="text-[#5E5E5E] mt-2 text-sm">The link may be expired or already used.</p>
            <Link to="/login" className="mt-8 inline-block text-[#1C3F35] underline">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
